import { render, staticRenderFns } from "./FaultCard.vue?vue&type=template&id=dc016784&scoped=true&"
import script from "./FaultCard.vue?vue&type=script&lang=js&"
export * from "./FaultCard.vue?vue&type=script&lang=js&"
import style0 from "./FaultCard.vue?vue&type=style&index=0&id=dc016784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc016784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VLayout})
